import React from "react";
import { Newspaper } from "lucide-react";
import { BACKEND_URL } from "../../lib/api";
import { useNewsWall, useRotate } from "../../pages/NewsWall";

export function NewsCorner({ slug }) {
  const [wall] = useNewsWall(slug);
  const cards = wall?.cards || [];
  const i = useRotate(wall);
  if (!cards.length) return null;
  const c = cards[i];
  return (
    <div data-testid="screen-news-corner">
      <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-3 flex items-center gap-2"><Newspaper className="w-4 h-4 text-[#d41a24]" /> Breaking news</p>
      <img key={c.item_id} src={`${BACKEND_URL}${c.card_url}`} alt={c.headline} className="w-full aspect-square object-cover rounded-2xl animate-in fade-in duration-700" />
    </div>
  );
}
